import { getCookie } from '@rover/rsdk/src/modules/Network/cookies';

import sanitizeCsrf from './axios/sanitizeCsrf';

export const DEFAULT_CSRF_COOKIE_NAME = 'csrftoken';
export const CSRF_META_TAG_NAME = 'csrf-cookie-name';

export const getCsrfCookieName = (): string => {
  const meta = document.querySelector(`meta[name=${CSRF_META_TAG_NAME}]`);
  const metaCookieName = meta && meta.getAttribute('content');
  return metaCookieName || DEFAULT_CSRF_COOKIE_NAME;
};

export const getCsrfToken = (): string | null => {
  const rawCookie = getCookie(getCsrfCookieName());
  return sanitizeCsrf(rawCookie);
};

export default getCsrfToken;
